import { Component, OnInit } from '@angular/core';
import {RegisterService} from '../../api/register/register.service';
import {Router} from '@angular/router';
// import {RegisterService} from '../../api/register/register.service'
// import { FormsModule } from '@angular/forms';
// import { NgModule }      from '@angular/core';
declare var $: any;
declare var jQuery: any;



@Component({
  selector: 'cat-page',
  templateUrl: './register.html'
})

export class PagesRegister implements OnInit {

  emailId: String;
  mobileno: String;
  password: String;
  repassword : String;
  isActive : boolean;
  resRegister : any;

  constructor(
      private registerService: RegisterService,
      private router: Router
  ) {
    this.isActive = false;
  }

  ngOnInit() {

    $(function() {

      // Form Validation
      // $('#form-validation').validate({
      //   submit: {
      //     settings: {
      //       inputContainer: '.form-group',
      //       errorListClass: 'form-control-error',
      //       errorClass: 'has-danger'
      //     }
      //   }
      // });

      // Show/Hide Password
      $('.password').password({
        eyeClass: '',
        eyeOpenClass: 'icmn-eye',
        eyeCloseClass: 'icmn-eye-blocked'
      });

      // Switch to fullscreen
      // $('.switch-to-fullscreen').on('click', function () {
      //   $('.cat__pages__login').toggleClass('cat__pages__login--fullscreen');
      // })
      //
      // // Change BG
      // $('.random-bg-image').on('click', function () {
      //   var min = 1, max = 5,
      //     next = Math.floor($('.random-bg-image').data('img')) + 1,
      //     final = next > max ? min : next;
      //
      //   $('.random-bg-image').data('img', final);
      //   $('.cat__pages__login').data('img', final).css('backgroundImage', 'url(assets/modules/pages/common/img/login/' + final + '.jpg)');
      // })

    });

  }

  iRegister() {
    let registeruser = {
      mobileno: this.mobileno,
      password: this.password,
      emailId : this.emailId
    }

    this.registerService.registerUser(registeruser).subscribe( data =>{
      this.resRegister = JSON.stringify(data);
      if (data.code == 1110) {
        this.router.navigate(['/']);
      } else if (data.code == 1101) {
        this.password = '';
        this.repassword = '';
      } else if (data.code == 1102) {
        this.repassword = '';
        this.password = '';
      } else if (data.code == 1103) {
        this.repassword = '';
        this.password = '';
      }else if (data.code == 1104) {
        this.repassword = '';
        this.password = '';
      }else if (data.code == 1105) {
        this.repassword = '';
        this.password = '';
      }else if (data.code == 1106) {
        this.repassword = '';
        this.password = '';
      } else {
        alert(data.code)
        this.mobileno = '';
        this.password = '';
        this.emailId = '';
        this.repassword = '';
        // console.log(this.resRegister)
        this.router.navigate(['../pages/register']);

      }
    });
  }
}




// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/pages/register.page.ts